import { POPULATE_CATEGORIES, POPULATE_LEVERANCIERS, TOGGLE_CATEGORY_FILTER, UPDATE_SEARCH_TERM } from "./types";

const DEFAULT_STATE = {
    categories: [],
    leveranciers: [],
    selectedCategory: {},
    searchTerm: "",
}


const reducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case POPULATE_CATEGORIES:
            return {...state, categories: action.categories };
        case POPULATE_LEVERANCIERS:
            return {...state, leveranciers: action.leveranciers};
        case TOGGLE_CATEGORY_FILTER:
            return {...state, selectedCategory: action.checked ? action.category : null};
        case UPDATE_SEARCH_TERM:
            return {...state, searchTerm: action.term};
        default:
            return state;
    }
};

export default reducer;